var _style, _path, _path2, _path3, _path4, _path5, _path6, _line, _line2, _line3, _path7, _circle;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBloodVolume(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 40 40",
    style: {
      enableBackground: "new 0 0 40 40"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:none;stroke:#192852;}\r\n\t.st1{fill:#232222;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M36.3,14.9c0,0-0.2,5.1-7.8,8.5c-1.6-0.7-6.8-3.5-7.8-8.5c0-0.8,0.1-6.2,5.6-4.6c0.8,0.5,1.6,1.5,1.6,1.5 s0.3,1,1.3-0.2c1-1.2,4.6-3.9,7.1,1.4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M21.5,17.1c0,0,3.3-1.8,6.8,0c1,0.6,3,1.8,6.9,0.9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M11.4,24.9c0,0,0.1,6,0,9.7c-0.1,3.7,3.3,3,3.2,2.9c3.1-0.1,2.5-2.8,2.5-2.8s0-3.7,0-6.4 c-0.1-3.6,1.9-3.5,2.8-3.7c3.2,0.2,2.8,2.7,2.8,2.7s0.1,3.3,0,6.9c-0.1,3.5,2.4,3.2,3,3.3c3.6-0.2,2.8-3.2,2.8-3.2v-11"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M12.8,22.3v1.6c0,0,0.3,0.9-0.9,0.8c-1.3-0.1-1.3-0.1-1.3-0.1S10,24.8,10,23.8s0-1.5,0-1.5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M17,22c0,0,1.4,0.1,1.4-0.7c0-1.2,0-15.1,0-15.1s0.3-1-1-1s-3.1,0-3.1,0s-0.6,0.1-0.6-1S14,2,11.4,2 c-1,0.1-2.2-0.2-2,2.3c0,0.6,0.2,0.9-1.2,0.9s-2.8,0-2.8,0S4.8,5.1,4.8,6s0,15.3,0,15.3s-0.1,0.9,0.8,0.9C6.6,22.1,17,22,17,22z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M12.3,8.5h3c0,0,0.4,0,0.4,0.8c0,0.8,0,9.7,0,9.7s0,0.6-1,0.6s-6.7,0-6.7,0s-0.7,0.1-0.7-0.9c0-1,0-9.7,0-9.7 s0-0.5,0.8-0.5s2.5,0,2.5,0"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 11.5,
    y1: 19.6,
    x2: 11.5,
    y2: 22.1
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 15.7,
    y1: 14.2,
    x2: 18.4,
    y2: 14.2
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 4.8,
    y1: 14.2,
    x2: 7.3,
    y2: 14.2
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M12,11.8l1.2,2.3c0,0,0.7,1.9-1,2.6c-0.4,0.1-2.5,0.3-2.3-2.1c0.3-1,1.4-2.8,1.4-2.8S11.5,10.1,12,11.8z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 11.5,
    cy: 4.4,
    r: 0.5
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBloodVolume);
export default __webpack_public_path__ + "static/media/BloodVolume.0eed5bc405259c55b01ac76072ffec99.svg";
export { ForwardRef as ReactComponent };